export default __webpack_public_path__ + "static/media/documents-crm.c5476ba5.svg";